import { Button, Stack, TextField } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers-pro'
import { useForm } from 'react-hook-form'

export interface FirstNFreeDiscountComponentProps {
  onCreateFirstNFreeDiscount: (data: FirstNFreeDiscountForm) => void
  isPatching: boolean
}

export interface FirstNFreeDiscountForm {
  numberOfFreeItems: number
  expirationDate: Date | undefined
}

export const FirstNFreeDiscountComponent = ({ onCreateFirstNFreeDiscount, isPatching }: FirstNFreeDiscountComponentProps) => {
  const form = useForm<FirstNFreeDiscountForm>({
    defaultValues: {
      numberOfFreeItems: 0,
      expirationDate: undefined,
    },
  })

  return (
    <>
      <Stack
        direction="row"
        sx={{
          flex: 1,
          gap: 2,
        }}
      >
        <TextField
          slotProps={{ htmlInput: { 'aria-label': 'first-n-free-count' } }}
          label="Number of free items"
          type="number"
          fullWidth
          {...form.register('numberOfFreeItems', { valueAsNumber: true })}
          error={Boolean(form.formState.errors.numberOfFreeItems)}
          helperText={form.formState.errors.numberOfFreeItems?.message}
        />
      </Stack>
      <DatePicker
        slotProps={{ textField: { 'aria-label': 'discount-expiration-date' } }}
        label="Expiration date"
        onChange={(date) => form.setValue('expirationDate', date?.toDate())}
      />
      <Button loading={isPatching} onClick={form.handleSubmit((data) => onCreateFirstNFreeDiscount(data))} variant="contained">
        Create Discount
      </Button>
    </>
  )
}
